const baseOrder = {
  'baseOrder.orderStatus': 'Order Status',
  'baseOrder.orderStatus.placeholder': 'Select order status',
  'baseOrder.orderStatus.toBeConfirmed': 'To Be Confirmed',
  'baseOrder.orderStatus.confirmed': 'Confirmed',
  'baseOrder.orderStatus.toBeShipped': 'To Be Shipped',
  'baseOrder.orderStatus.partiallyShipped': 'Partially Shipped',
  'baseOrder.orderStatus.completed': 'Completed',
  'baseOrder.orderStatus.cancelled': 'Cancelled',

  'baseOrder.shipmentStatus': 'Shipment Status',
  'baseOrder.shipmentStatus.placeholder': 'Select shipment status',
  'baseOrder.shipmentStatus.notShipped': 'Not Shipped',
  'baseOrder.shipmentStatus.partiallyShipped': 'Partially Shipped',
  'baseOrder.shipmentStatus.shipped': 'Shipped',
  'baseOrder.shipmentStatus.abnormalShipping': 'Shipping Exception',

  'baseOrder.paymentStatus': 'Payment Status',
  'baseOrder.paymentStatus.placeholder': 'Select payment status',
  'baseOrder.paymentStatus.unpaid': 'Unpaid',
  'baseOrder.paymentStatus.partiallyPaid': 'Partially Paid',
  'baseOrder.paymentStatus.paid': 'Paid',
  'baseOrder.paymentStatus.paymentException': 'Payment Exception',

  'baseOrder.orderNumber': 'Order Number',
  'baseOrder.orderNumber.placeholder': 'Enter order number',
  'baseOrder.orderTime': 'Order Date',
  'baseOrder.customerName': 'Customer Name',
  'baseOrder.skuTotal': 'Total SKUs',
  'baseOrder.totalAmount': 'Total Amount',
  'baseOrder.fee': 'Fees',
};

export default baseOrder;
